import { useCallback } from 'react';
import useDropdownOptions from 'hooks/useDropdownOptions';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { entityOptions } from '../utils/subscriptionConsts';

const msgEntityPrefix = 'push.api.create.settings.entity';

export const useEntityType = (entityIndex = 0) => {
    const options = useDropdownOptions(entityOptions, msgEntityPrefix);
    const { value: type, onChange: setType } = useFormFieldValue({
        field: `entities.${entityIndex}.type`,
        isAbsolute: true,
    });

    const setTypeOnChange = useCallback(
        ({ value: entity }) => {
            setType(entity);
        },
        [setType]
    );

    return { options, type, setTypeOnChange };
};
